import { C44TestimonialCardFields } from './C44TestimonialCard.types';
import { TestimonialCardProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function GetTestimonialCardModel(fields?: C44TestimonialCardFields): TestimonialCardProps {
  const { renderText, renderRichText } = useConditionalRendering();

  const testimonialCard: TestimonialCardProps = {
    testimonialText: renderRichText(fields?.TestimonialText),
    testimonialAuthor: renderText(fields?.TestimonialAuthor),
    testimonialAuthorTitle: renderText(fields?.TestimonialAuthorTitle),
  };
  return testimonialCard;
}
